import { PhaseLayout } from "../../components/PhaseLayout";
import { StepGenerator } from "../../components/StepGenerator";

const STEPS = [
  {
    type: "lead_magnet",
    title: "Lead Magnet Blueprint",
    description: "Design a high-value freebie that attracts your ideal clients.",
    fields: [
      { key: "audience", label: "Target Audience", placeholder: "e.g., Busy entrepreneurs wanting to automate", required: true },
      { key: "problem", label: "Main Problem to Solve", placeholder: "e.g., Spending too much time on repetitive tasks", required: true, type: "textarea" },
      { key: "approach", label: "Your Unique Approach", placeholder: "e.g., The 'Calm Systems' method", required: true },
      { key: "format", label: "Desired Format", placeholder: "e.g., PDF checklist, mini-course, template pack", required: true }
    ]
  },
  {
    type: "content_pillars",
    title: "Content Pillar Structure",
    description: "Establish your core content themes for consistent, strategic posting.",
    fields: [
      { key: "business_focus", label: "Business Focus Area", placeholder: "e.g., Online business strategy for introverts", required: true },
      { key: "pain_points", label: "Audience Pain Points", placeholder: "e.g., Overwhelm, inconsistency, imposter syndrome", required: true, type: "textarea" },
      { key: "expertise", label: "Your Expertise Areas", placeholder: "e.g., Systems, mindset, marketing strategy", required: true, type: "textarea" },
      { key: "platforms", label: "Preferred Platforms", placeholder: "e.g., Email newsletter, Instagram, podcast", required: true }
    ]
  },
  {
    type: "email_sequence",
    title: "Email Sequence Planner",
    description: "Map out a nurture sequence that builds trust and guides to purchase.",
    fields: [
      { key: "lead_magnet", label: "Lead Magnet Topic", placeholder: "e.g., 5-Day Clarity Challenge", required: true },
      { key: "product", label: "Product to Sell", placeholder: "e.g., Business Blueprint Course", required: true },
      { key: "awareness", label: "Audience Awareness Level", placeholder: "e.g., Problem-aware but solution-unaware", required: true },
      { key: "length", label: "Desired Sequence Length", placeholder: "e.g., 5-7 emails over 2 weeks", required: true }
    ]
  },
  {
    type: "product_outline",
    title: "Product Outline",
    description: "Structure your digital product for maximum transformation and completion.",
    fields: [
      { key: "product_type", label: "Product Type", placeholder: "e.g., Self-paced course, group program, template bundle", required: true },
      { key: "transformation", label: "Core Transformation", placeholder: "e.g., From overwhelmed to organized in 30 days", required: true },
      { key: "duration", label: "Target Duration", placeholder: "e.g., 6 weeks, 4 modules, 90-day program", required: true },
      { key: "price", label: "Price Point", placeholder: "e.g., $297, $997, $47/month", required: true }
    ]
  }
];

export default function AssetsPhase() {
  return (
    <PhaseLayout 
      phaseNumber={2}
      phaseName="Assets"
      phaseSubtitle="Build Your Engine"
      phaseDescription="Create the strategic assets that attract, nurture, and convert your ideal clients. These are the building blocks of your business."
      days="Days 4-7"
      nextPhase={{ number: 3, name: "Authority", path: "/phase/authority" }}
      prevPhase={{ number: 1, name: "Clarity", path: "/phase/clarity" }}
    >
      {STEPS.map((step, index) => (
        <StepGenerator
          key={step.type}
          room="asset_builder"
          generatorType={step.type}
          stepNumber={index + 1}
          title={step.title}
          description={step.description}
          fields={step.fields}
          defaultOpen={index === 0}
        />
      ))}
    </PhaseLayout>
  );
}
